
const CallToActionHospitalitySection = () => {
    return (
        <div>
            <section className="pricing-section" style={{ backgroundColor: "white" }}>
                <div className="container">
                    <div className="basic-flex progress" style={{ flexDirection: "column", alignItems: "center" }}>

                        <div className="basic-flex__content" style={{gap:"10px"}}  >
                            <h2 className="purple" >
                                Rating based Call to Action
                            </h2>
                            <span>Customize what users see after submitting feedback.</span>
                            <div className="basic-flex-row" style={{marginTop: "50px"}}>
                                <div style={{  maxWidth: "300px", minWidth: "200px" }}>
                                    <ul>
                                        
                                        <li><strong>Lead </strong> your users who rate you highly to rate your business on Google.  </li>
                                    </ul>
                                </div>
                                <div style={{ maxWidth: "600px", maxHeight: "420px" }}>
                                    <img
                                        className="basic-flex-phone-screenshot box-shadow"
                                        src="images/highRatingView.png"
                                        alt="activities"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="basic-flex__content" style={{paddingTop:"20px"}}>
                            <div className="basic-flex-row" >
                                <div style={{ maxWidth: "300px", minWidth: "200px"}}>
                                    <ul>
                                        <li>As for lower rating feedbacks, provide a personal message to the customer that reaffirms your commitment to quality </li>
                                    </ul>
                                </div>
                                <div style={{ maxWidth: "600px", maxHeight: "420px" }}>
                                    <img
                                        className="basic-flex-phone-screenshot"
                                        src="images/lowRatingView.png"
                                        alt="activities"
                                        style={{ borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"}}
                                    />
                                </div>
                            </div>
                            <br />
                        </div>

                    </div>
                </div>

            </section>
        </div>
    );
};

export default CallToActionHospitalitySection;
